import io from 'socket.io-client'

const socket = io.connect('http://210.3.12.74:9100')

export { socket }
